/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type IrrServiceUserEntity = 'UNKNOWN_ENTITY' | 'IRR' | 'CDVX' | 'LAMBDA' | 'CR' | 'CR_FUNC' | 'SDDC_PROVIDER_GCP' | 'SDDC_PROVIDER_EVS';

export const IrrServiceUserEntity = {

    UNKNOWN_ENTITY: 'UNKNOWN_ENTITY' as IrrServiceUserEntity,

    IRR: 'IRR' as IrrServiceUserEntity,

    CDVX: 'CDVX' as IrrServiceUserEntity,

    LAMBDA: 'LAMBDA' as IrrServiceUserEntity,

    CR: 'CR' as IrrServiceUserEntity,

    CR_FUNC: 'CR_FUNC' as IrrServiceUserEntity,

    SDDC_PROVIDER_GCP: 'SDDC_PROVIDER_GCP' as IrrServiceUserEntity,

    SDDC_PROVIDER_EVS: 'SDDC_PROVIDER_EVS' as IrrServiceUserEntity
};

